const routeDetails = {
  ADVICE: {
    metaTitle: 'Advice Page',
    title: 'Advice',
    url: '/advice',
  },
  ADVICE_DETAIL: {
    link: '/advice/',
    metaTitle: 'Advice Page',
    title: 'Advice Detail',
    url: '/advice/:slug',
  },
  CONTACT: {
    metaTitle: 'Contact Page',
    title: 'Contact',
    url: '/contact',
  },
  FORMULA: {
    metaTitle: 'Formula Page',
    title: 'Formula',
    url: '/formula',
  },
  FULL_ANALYSIS: {
    metaTitle: 'Full Analysis',
    title: 'Full Analysis',
    url: '/full-analysis',
  },
  HOME: {
    metaTitle: 'Home Page',
    title: 'Home',
    url: '/',
  },
  PRIVACY_POLICY: {
    metaTitle: 'Privacy Policy Page',
    title: 'Privacy Policy',
    url: '/privacy-policy',
  },
  QUESTIONS: {
    metaTitle: 'Questions Page',
    title: 'Questions',
    url: '/questions',
  },
  RESULTS: {
    metaTitle: 'Results Page',
    title: 'Results',
    url: '/results',
  },
};

export default routeDetails;



// WEBPACK FOOTER //
// ./src/constants/routeDetails.js